import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CmsConfig, ConfigModule, I18nModule, RoutingService, SearchboxService, TranslationService, UrlModule, WindowRef } from "@spartacus/core";
import { IconModule, MediaModule, OutletPosition, provideOutlet, SearchBoxComponentService } from "@spartacus/storefront";
import { SearchBoxComponent } from './search-box/search-box.component';
import { CustomSearchBoxComponentService } from './search-box/search-box.service';

@NgModule({
  declarations: [SearchBoxComponent],
  imports: [
    CommonModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    RouterModule,
    FormsModule,

    ConfigModule.withConfig({
      cmsComponents: {
        SearchBox: {
          component: SearchBoxComponent,
          providers: [
            {
              provide: SearchBoxComponentService,
              useClass: CustomSearchBoxComponentService,
              deps: [
                SearchboxService,
                RoutingService,
                TranslationService,
                WindowRef,
              ],
            },

          ],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'SiteLinks',
      position: OutletPosition.BEFORE,
      component:SearchBoxComponent,
    }),
    {
      provide: SearchBoxComponentService,
      useClass: CustomSearchBoxComponentService,
    }

  ],

  exports: [SearchBoxComponent],
})
export class SearchBoxModule {}
